import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M21.334 31.698V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a51 51 0 0 1-5.334-.314V.314A51 51 0 0 1 16 0c1.83.016 3.676.12 5.333.318",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m16 10.726.022-.06.008.14c.365.962.754 1.95 1.546 2.716a3.7 3.7 0 0 0-.998-.15v4.232l1.233.178c.044-.005.058-.072.058-.162.119-1.314.44-2.418.808-3.56.027-.157.494-.753.134-.648-.044.006-.526.196-.45.105.656-.658 1.615-1.132 2.546-1.272.082-.02.13.02.057.112-1.236 1.843-2.27 4.018-2.26 6.6-.48 0-1.645-.276-2.126-.276v2.986h-1.156V18.68c-.482 0-1.645.275-2.126.275.01-2.58-1.024-4.756-2.26-6.6-.073-.091-.025-.131.057-.111.931.14 1.89.614 2.546 1.272.076.091-.405-.099-.45-.105-.36-.105.107.491.134.647.369 1.143.69 2.247.808 3.56 0 .091.014.158.058.163l1.233-.178v-4.231c-.29-.007-.74.066-.998.149.792-.765 1.181-1.754 1.546-2.717l.008-.138zc-.008-.02 0 0 0 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBrb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBrb_default = SvgFlagBrb;

export { FlagBrb_default as default };
